import React, { useState } from "react";
import { RadioButton } from "primereact/radiobutton";
import Modal from "react-bootstrap/Modal";
import Axios from "../../api/Axios";
import storage from "../../Services/Storage";
import * as XLSX from "xlsx";

const InformationModal = ({
    exportbtnpopup,
    setExportbtnpopup,
    setExcelLoading,
}) => {
    const auth = storage.getLocal("user");
    const categories = [
        { name: "Active Customers", key: "A" },
        { name: "All Customers", key: "ALL" },
    ];

    const [selectedCategory, setSelectedCategory] = useState(categories[0]);
    const downloadAllcustdata = async () => {
        setExportbtnpopup(false);
        setExcelLoading(true);
        let strfromdate = "01/01/1890";
        let strtodate = "01/01/9999";
        let custTag = selectedCategory.key;
        try {
            setExcelLoading(true);
            const exportcustdata_URL = "CustomerMast/GetCustomerExportData?";
            const exportalldata = `${exportcustdata_URL}CICode=${auth.CICode}&strdist=${auth.CompId}&strfromdate=${strfromdate}&strtodate=${strtodate}&custTag=${custTag}`;
            const response = await Axios.get(exportalldata);

            let date = new Date();
            let day = date.getDate();
            let exactmonth = (date.getMonth() + 1).toString().padStart(2, "0");
            let year = date.getFullYear();
            let uniqueNo = `Customer_Master_Report_${day}${exactmonth}${year}`;

            var wb = XLSX.utils.book_new();
            //   let MapData = response.data.map((val) => {
            //     var dateString = val["Creation Date"];
            //     var newData = dateString.replace(/(\d+[/])(\d+[/])/, "$2$1");
            //     var data = new Date(newData);
            //     var dateString1 = val["Expiry Date"];
            //     var newData1 = dateString1.replace(/(\d+[/])(\d+[/])/, "$2$1");
            //     var data1 = new Date(newData1);
            //     return {
            //       ...val,
            //       "Creation Date": data,
            //       "Expiry Date": data1,
            //     };
            //   });
            let MapData = response?.data.map((val) => {
                let convfrmdt =
          val["Creation Date"] === "" || val["Creation Date"] === null
              ? ""
              : new Date(val["Creation Date"]?.replace(/(\d+[/])(\d+[/])/, "$2$1"));
                let convenddt =
          val["Expiry Date"] === "" || val["Expiry Date"] === null
              ? ""
              : new Date(val["Expiry Date"]?.replace(/(\d+[/])(\d+[/])/, "$2$1"));
                return { ...val, "Creation Date": convfrmdt, "Expiry Date": convenddt };
            });
            var ws = XLSX.utils.json_to_sheet(MapData);
            XLSX.utils.book_append_sheet(wb, ws, uniqueNo);
            XLSX.writeFile(wb, `${uniqueNo}.xlsx`);
        } catch (error) {
            console.log(error);
        } finally {
            setExcelLoading(false);
        }
    };

    const closebtnclick = () => {
        setExportbtnpopup(false);
    };

    return (
        <div className="col-12 pt-0 pb-4">
            <Modal
                show={exportbtnpopup}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
            Information
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="col-md-12 col-lg-12 col-sm-12 py-3">
                        <div className="mt-0 text-center">
                            {categories.map((category) => {
                                return (
                                    <div key={category.key} className="d-inline-flex pe-3">
                                        <RadioButton
                                            inputId={category.key}
                                            name="category"
                                            value={category}
                                            onChange={(e) => setSelectedCategory(e.value)}
                                            checked={selectedCategory.key === category.key}
                                        />
                                        <label htmlFor={category.key} className="mx-2">
                                            {category.name}
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="float-end">
                        <button
                            type="button"
                            className="btn btn-primary me-3"
                            onClick={downloadAllcustdata}
                        >
              Ok
                        </button>
                        <button
                            type="button"
                            className="btn btn-cancel-red"
                            onClick={closebtnclick}
                        >
              Close
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default InformationModal;
